__webpack_require__.p = "/upusa/livescoring/";